import { useEffect } from 'react'
import Lenis from 'lenis'
import Header from './components/Header'
import HeroSection from './components/sections/HeroSection'
import MarqueeSection from './components/sections/MarqueeSection'
import ServicesSection from './components/sections/ServicesSection'
import HowItWorksSection from './components/sections/HowItWorksSection'
import WhyChooseSection from './components/sections/WhyChooseSection'
import TestimonialsSection from './components/sections/TestimonialsSection'
import CTAFormSection from './components/sections/CTAFormSection'
import FooterSection from './components/sections/FooterSection'
import WhatsAppFloat from './components/WhatsAppFloat'
import './App.css'

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    })

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
    const rafId = requestAnimationFrame(raf)

    return () => {
      cancelAnimationFrame(rafId)
      lenis.destroy()
    }
  }, [])

  return (
    <div className="min-h-screen bg-[#F7F7F7] font-inter">
      <Header />
      <main>
        <HeroSection />
        <MarqueeSection />
        <ServicesSection />
        <HowItWorksSection />
        <WhyChooseSection />
        <TestimonialsSection />
        <CTAFormSection />
      </main>
      <FooterSection />
      <WhatsAppFloat />
    </div>
  )
}

export default App
